import React from "react";
export const TeamsContext = React.createContext({});
